import { curry } from 'ramda'
import React, { useCallback } from 'react'

import { useChecklistFormActions } from '../../../../_form/ChecklistFormHandler'

const useHandleGroupedConfigChange = () => {
  const { handleSelectedQuestionChange } = useChecklistFormActions()
  return useCallback(
    curry((field, value) => {
      handleSelectedQuestionChange(field, value)
      if (value) return

      switch (field) {
        case 'notesEnabled':
          handleSelectedQuestionChange('notesRequired', false)
          break
        case 'photosEnabled':
          handleSelectedQuestionChange('photosRequired', false)
          handleSelectedQuestionChange('photosFromGallery', false)
      }
    }),
    []
  )
}

export default useHandleGroupedConfigChange
